// extracted by mini-css-extract-plugin
export default {"warpper":"transfer_warpper__bLuHx","switchWarpper":"transfer_switchWarpper__zuKm8","switch":"transfer_switch__R8qTI","button":"transfer_button__jKYm7"};